var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},[_c('span',{staticClass:"value",style:({
      color: _vm.colorStatus.color,
      backgroundColor: _vm.colorStatus.background
    })},[_vm._v(" "+_vm._s(_vm.value)+_vm._s(_vm.unit)+" ")]),_c('div',{staticClass:"gauges"},[_vm._l((_vm.backgroundsColors),function(color,idx){return _c('div',{key:idx,staticClass:"gauge",style:(("background-color: " + color + "; border: 3px " + color + " solid"))})}),_c('div',{staticClass:"gauge-value",style:({
        left: _vm.valuePosition,
        backgroundColor: _vm.colorStatus.color
      })})],2),_c('span',{class:("side " + _vm.side)},[_vm._v(_vm._s(_vm.$t(("commons.standards." + (_vm.sides[_vm.side])))))])])}
var staticRenderFns = []

export { render, staticRenderFns }